module.exports = __webpack_public_path__ + "media/en_us_s1_Anthony.a17472fd.mp3";